import { combineReducers } from 'redux';

import { reducer as formReducer } from 'redux-form';
import { routerReducer } from 'react-router-redux';
import pagination from './pagination';

import { prospectReducer as prospect } from 'src/redux/prospects/prospect.reducer';
import { donorReducer as donor } from 'src/redux/donors/donor.reducer';
import { fundraisersReducer as fundraisers } from 'src/redux/fundraisers/fundraiser.reducer';
import { fundraiserAssignmentTypeReducer as fundraiserAssignmentTypes } from 'src/redux/fundraiserAssignmentTypes/fundraiserAssignmentType.reducer';
import { activityReducer as activity } from 'src/redux/activities/activity.reducer';
import { activityStatusReducer as activityStatuses } from 'src/redux/activityStatuses/activityStatus.reducer';
import { activityTypeReducer as activityTypes } from 'src/redux/activityTypes/activityType.reducer';
import { giftBucketReducer as giftBuckets } from 'src/redux/giftBuckets/giftBucket.reducer';
import { giftDateBucketReducer as giftDateBuckets } from 'src/redux/giftDateBuckets/giftDateBucket.reducer';
import { giftReducer as gifts } from 'src/redux/gifts/gifts.reducer';
import { noteReducer as notes } from 'src/redux/notes/notes.reducer';
import { countryReducer as countries } from 'src/redux/countries/country.reducer';
import { teamReducer as teams } from 'src/redux/teams/team.reducer';
import { stageReducer as stages } from 'src/redux/stages/stages.reducer';
import { opportunitiesReducer as opportunities } from 'src/redux/opportunities/opportunity.reducer';
import { opportunityStatusReducer as opportunityStatuses } from 'src/redux/opportunityStatuses/opportunityStatus.reducer';
import { opportunityPurposesReducer as opportunityPurposes } from 'src/redux/opportunityPurposes/opportunityPurposes.reducer';
import { authUserReducer as authUser } from 'src/redux/authUsers/authUser.reducer';
import { authOrganizationReducer as authOrganization } from 'src/redux/authOrganizations/authOrganization.reducer';
import { appOrganizationReducer as appOrganization } from 'src/redux/appOrganizations/appOrganization.reducer';
import { blackbaudUserReducer as blackbaudUser } from 'src/redux/blackbaudUsers/blackbaudUser.reducer';
import { importJobReducer as importJob } from 'src/redux/importJobs/importJob.reducer';
import { reminderReducer as reminders } from 'src/redux/reminders/reminder.reducer';
import { lybuntReducer as lybunt } from 'src/redux/lybunt/lybunt.reducer';
import { noteTypeReducer as noteTypes } from 'src/redux/noteTypes/noteTypes.reducer';

import { CLEAR_APP_STATE } from 'src/redux/logout/logout.action';

const appReducer = combineReducers({
	form: formReducer,
	router: routerReducer,
	pagination,
	prospect,
	donor,
	fundraisers,
	fundraiserAssignmentTypes,
	activity,
	activityStatuses,
	activityTypes,
	giftBuckets,
	giftDateBuckets,
	gifts,
	notes,
	countries,
	teams,
	stages,
	opportunities,
	opportunityStatuses,
	opportunityPurposes,
	authUser,
	authOrganization,
	appOrganization,
	blackbaudUser,
	importJob,
	reminders,
	lybunt,
	noteTypes,
});

const rootReducer = (state, action) => {
	if (action.type === CLEAR_APP_STATE) {
		const { router, form } = state;
		state = { router, form };
	}

	return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/data/store/root.reducer.js